import { render, staticRenderFns } from "./BackgroundVideoV2.vue?vue&type=template&id=31d223dc&scoped=true"
import script from "./BackgroundVideoV2.vue?vue&type=script&lang=js"
export * from "./BackgroundVideoV2.vue?vue&type=script&lang=js"
import style0 from "./BackgroundVideoV2.vue?vue&type=style&index=0&id=31d223dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d223dc",
  null
  
)

export default component.exports